/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';
import Router, {Route} from 'vue-router';
import {notFoundGuard} from '@/router/not-found-guard';
import {focusHook} from '@/router/focus-hook';
import {authenticated} from '@/router/authentication-guard';
import Home from '@/views/Home/index.vue';
import {settingsInjectionGuard} from '@/router/settings-injection-guard';
import ActiveCommunityChallenge from '@/views/ActiveCommunityChallenge/index.vue';
import CommunityChallengePreview from '@/views/CommunityChallengePreview/index.vue';
import TrophyCabinet from '@/views/TrophyCabinet/index.vue';

Vue.use(Router);

/**
 * Router object exposed for view navigation.
 *
 * This example router contains an example of static, nested and component based rendering.
 * e.g. /about (static)
 * e.g. /home (component)
 * e.g. /nested/terms (nested)
 *
 * Example route guards:
 * 1. authenticated - guard to check vuex session module for non-expired JWT token.
 * 2. steamAuthenticateReady - guard to check that steam authentication route contains properly configured params.
 * 3. notFoundGuard - route not found guard (typically used to redirect to a 404 etc).
 * 4. focusHook - resets the focus on a route change.
 *
 * Example: adding Steam authentication routes with steam guard
 * {
 *      path: '/steam/authenticate',
 *      name: 'authenticate',
 *      beforeEnter: steamAuthenticateReady,
 *      props: (route: Route) => ({ code: route.query.code }),
 *      pathToRegexpOptions: { strict: true },
 *  }
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
const router: Router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    // tslint:disable-next-line
    scrollBehavior: () => {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/',
            name: 'login',
            component: Home,
        },

        {
            path: '/trophy-cabinet/:type?',
            name: 'trophy-cabinet',
            component: TrophyCabinet,
            beforeEnter: authenticated,
            // tslint:disable-next-line
            props: (route: Route) => ({ type: route.params.type }),
        },

        {
            path: '/community-challenges/active',
            name: 'community-challenges-active',
            component: ActiveCommunityChallenge,
            beforeEnter: authenticated,
        },

        {
            path: '/community-challenges/preview',
            name: 'community-challenges-preview',
            component: CommunityChallengePreview,
            beforeEnter: authenticated,
        },
    ],
});

router.beforeEach(settingsInjectionGuard);
router.beforeEach(notFoundGuard);
router.afterEach(focusHook);

export default router;
